import React, { useState } from "react";
import { Loader2, Save } from "lucide-react";
import { adminApi } from "../../lib/adminApi";
import { useAuth } from "../../auth/AuthContext";

export default function AdminSettings() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg(null); setErr(null);
    if (next.length < 12) return setErr("New password must be at least 12 characters.");
    if (next !== confirm) return setErr("New password and confirmation don't match.");
    setSaving(true);
    const res = await adminApi.changePassword(current, next);
    setSaving(false);
    if (!res.ok) return setErr(res.error);
    setMsg("Password updated.");
    setCurrent(""); setNext(""); setConfirm("");
  };

  return (
    <div className="max-w-2xl" data-testid="admin-settings">
      <span className="overline">Account</span>
      <h1 className="font-display mt-2 text-3xl font-bold tracking-tight text-ridge-charcoal md:text-4xl">Settings</h1>
      <p className="mt-2 text-sm text-ridge-muted">Signed in as <strong>{user?.email}</strong>.</p>

      <form onSubmit={onSubmit} className="mt-8 rounded-md border border-ridge-border bg-white p-6 md:p-8" data-testid="admin-settings-form">
        <h2 className="font-display text-lg font-semibold text-ridge-charcoal">Change password</h2>
        <p className="mt-1 text-xs text-ridge-muted">Minimum 12 characters.</p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.14em] text-ridge-charcoal">Current password</label>
            <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} required autoComplete="current-password" data-testid="admin-settings-current" />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.14em] text-ridge-charcoal">New password</label>
            <input type="password" value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} required minLength={12} autoComplete="new-password" data-testid="admin-settings-new" />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.14em] text-ridge-charcoal">Confirm new password</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} required minLength={12} autoComplete="new-password" data-testid="admin-settings-confirm" />
          </div>
        </div>

        {err ? <p className="mt-4 rounded-md border border-red-200 bg-red-50 px-4 py-2 text-sm text-red-700">{err}</p> : null}
        {msg ? <p className="mt-4 rounded-md border border-green-200 bg-green-50 px-4 py-2 text-sm text-green-700">{msg}</p> : null}

        <button type="submit" disabled={saving} className="btn-primary mt-6" data-testid="admin-settings-submit">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Update password
        </button>
      </form>
    </div>
  );
}

const inputCls = "block w-full rounded-md border border-ridge-border bg-white px-3 py-2 text-sm focus:border-ridge-charcoal focus:outline-none focus:ring-2 focus:ring-ridge-charcoal/15";
